import { createSlice } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

const initialState = {
  interval: [],
  bookingInterval: [],
  days: [],
  availability: {},
  freeAvailability: {},
  holidays: [],
  openHours: [],
  closeHours: [],
  bookingTypes: [],
};

export const healersTimeAvailabilitySlice = createSlice({
  name: "healersTimeAvailability",
  initialState,
  reducers: {
    setInterval: (state, action) => {
      state.interval = action.payload;
    },
    setBookingInterval: (state, action) => {
      state.bookingInterval = action.payload;
    },
    setDays: (state, action) => {
      state.days = action.payload;
    },
    setAvailabililty: (state, action) => {
      state.availability = action.payload;
    },
    setFreeAvailabililty: (state, action) => {
      state.freeAvailability = action.payload;
    },
    setHolidays: (state, action) => {
      state.holidays = action.payload;
    },
    setOpenHours: (state, action) => {
      state.openHours = action.payload;
    },
    setCloseHours: (state, action) => {
      state.closeHours = action.payload;
    },
    setBookingTypes: (state, action) => {
      state.bookingTypes = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, { payload }) => {
      //
    });
  },
});

export const {
  setBookingTypes,
  setInterval,
  setBookingInterval,
  setDays,
  setAvailabililty,
  setFreeAvailabililty,
  setHolidays,
  setOpenHours,
  setCloseHours,
} = healersTimeAvailabilitySlice.actions;
export default healersTimeAvailabilitySlice.reducer;
